import { createStore } from "vuex";

export default createStore({
	state: {
		userInfo:'fsasafsafsa',
		language:'zh_CN'
	},
	getters: {},
	mutations: {
		SETUSERINFO(state, val) {
			state.userInfo = val;
		},
		SETLANGUAGE(state, val) {
			state.language = val;
		},
	},
	actions: {
		setUserInfo({ dispatch, commit }, payload) {
			commit("SETUSERINFO", payload);
		},
	},
	modules: {},
});
